export default __webpack_public_path__ + "static/media/6eB.8023fd91.png";